import { Classifier } from "../classifierManager";

export enum InputName {
  searchType = "searchType",
  freeTextAadress = "freeTextAadress",
  county = "county",
  borough = "borough",
  village = "village",
  adsDetailAadress = "adsDetailAadress",
}

export interface Input {
  [InputName.searchType]?: Classifier;
  [InputName.freeTextAadress]?: string;
  [InputName.county]: Classifier;
  [InputName.borough]?: Classifier;
  [InputName.village]?: Classifier;
  [InputName.adsDetailAadress]?: string;
}

export enum AddressSearchType {
  ADS = "ADS",
  VABATEKST = "VABATEKST",
}
export enum RealEstateComplexAddressSearchType {
  ADS = "ADS",
  ADSOID = "ADSOID",
  FOREIGN = "FOREIGN",
}

export interface AddressSearch {
  searchType: Classifier;
}
